import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Alert,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import "./nodeBar.css";
import { URL_JDC_INTERPRETER } from "../../../constants";
import T from "../../atoms/translate";
import { t } from "../../../utils/utils";
export function NodeBar({
  children,
  title,
  lateralTitle,
  unsavedChanges,
  savingWorkflow,
  activeWorkflow,
  onSaveWorkflow,
  openDeployModal,
  project,
  intro,
}) {
  const [open, setOpen] = useState(true);
  const [redirect, setRedirect] = useState(null);
  const toggleRight = () => {
    setOpen(!open);
  };
  if (redirect) return <Redirect to={redirect} />;
  return (
    <>
      {!intro && (
        <div
          className={`rounded-left border-left border-bottom box-shadow-left box-shadow-bottom cursor-pointer nodebar-tab sidebar-tab ${
            open ? "move-to-left" : ""
          }`}
          onClick={toggleRight}
        >
          <div className="vertical-text text-center sidebar-tab-text">
            <span className={`arrow ${open ? "active" : ""}`} />
          </div>
        </div>
      )}
      <div
        className={`${intro ? "sidebar-intro" : "sidebar"} ${
          open && !intro ? "move-to-left" : ""
        } `}
        style={{ backgroundColor: "#f7f7f7" }}
      >
        <Container>
          <Row className="my-3">
            <Col xs="8" className="intro_step7">
              <UncontrolledButtonDropdown className="btn-block">
                <DropdownToggle caret color="primary">
                  <T i18nKey="probar" />
                </DropdownToggle>
                <DropdownMenu>
                  <a
                    href={`${URL_JDC_INTERPRETER}/project/${project}`}
                    target="_mycontrolledtab"
                    className="btn btn-primary btn-block fw-500 rounded-0"
                  >
                    Develop
                  </a>
                  <hr className="mt-0 mb-0" />
                  <a
                    href={`${URL_JDC_INTERPRETER}/project/${project}/master`}
                    target="_mycontrolledtab"
                    className="btn btn-primary btn-block fw-500 rounded-0 mt-0"
                  >
                    Master
                  </a>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </Col>
            <Col xs="4" className="">
              <Button
                color="secondary"
                className="rounded-circle"
                onClick={() => setRedirect(`/projects/${project}`)}
              >
                <FontAwesomeIcon icon={faTimes} className="mt-1" />
              </Button>
            </Col>
          </Row>
          <Row>
            <Col xs="12" className="text-center intro_step6">
              {savingWorkflow ? (
                <FontAwesomeIcon icon={faSyncAlt} className="mt-1" spin />
              ) : (
                <div
                  className={`${
                    unsavedChanges ? "bg-danger" : "bg-success"
                  } d-inline-block rounded-circle`}
                  style={{ width: "0.7rem", height: "0.7rem" }}
                ></div>
              )}
              <span className="font-size-08 ml-2">
                {savingWorkflow
                  ? t("guardando...")
                  : unsavedChanges
                  ? t("cambiosSinGuardar")
                  : t("guardado")}
              </span>
              {!savingWorkflow && unsavedChanges && (
                <div>
                  <Button
                    color="primary"
                    size="sm"
                    className="py-0"
                    onClick={onSaveWorkflow}
                  >
                    {t("guardar")}
                  </Button>
                </div>
              )}
            </Col>
            <Col xs="12">
              <hr className="mt-2 mb-4" />
            </Col>
          </Row>
          <Row className="intro_step5">
            <Col xs="12">
              <h1 className="font-size-12 fw-500">
                <T i18nKey="nodos" />
              </h1>
            </Col>
            <Col xs="12" className="">
              {activeWorkflow ? (
                <div className="nodes-container overflow-scroll-hidden rounded">
                  {children}
                </div>
              ) : (
                <Alert color="info" className="">
                  <T i18nKey="abreUnWorflowParaVerNodos" />
                </Alert>
              )}
            </Col>
          </Row>
          <div
            className="custom-fixed-bottom-right intro_step8"
            style={{ width: "220px" }}
          >
            <Button
              className="rounded-0 py-3 font-size-09 fw-600 "
              block
              color="primary"
              onClick={openDeployModal}
            >
              <T i18nKey="desplegarProyecto" />
            </Button>
          </div>
        </Container>

        <h4>{title}</h4>

        <div className="container-liner"></div>
      </div>
    </>
  );
}
